import { motion } from 'motion/react'
import { customerMotionTransition } from '../customer-area'
import type { AddressLabels } from './addressBookConfig'

type AddressEditorActionBarProps = {
  reducedMotion: boolean
  saving: boolean
  editingAddressId: string | null
  labels: AddressLabels
  savingLabel: string
  onSubmit: () => void
  onClose: () => void
}

export const AddressEditorActionBar = ({
  reducedMotion,
  saving,
  editingAddressId,
  labels,
  savingLabel,
  onSubmit,
  onClose,
}: AddressEditorActionBarProps) => (
  <div className="mt-4 flex flex-wrap items-center gap-2.5">
    <motion.button
      type="button"
      onClick={onSubmit}
      disabled={saving}
      whileTap={reducedMotion || saving ? undefined : { scale: 0.985 }}
      transition={customerMotionTransition}
      className="ca-btn-primary inline-flex h-9 items-center px-3 text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-60"
    >
      {saving ? savingLabel : editingAddressId ? labels.saveEdit : labels.saveNew}
    </motion.button>
    <motion.button
      type="button"
      onClick={onClose}
      whileTap={reducedMotion ? undefined : { scale: 0.985 }}
      transition={customerMotionTransition}
      className="ca-btn-secondary inline-flex h-9 items-center px-3 text-sm font-semibold"
    >
      {labels.cancel}
    </motion.button>
  </div>
)
